import { render, staticRenderFns } from "./PostListPlannedItem.vue?vue&type=template&id=11f8236a&scoped=true&"
import script from "./PostListPlannedItem.vue?vue&type=script&lang=js&"
export * from "./PostListPlannedItem.vue?vue&type=script&lang=js&"
import style0 from "./PostListItem.scss?vue&type=style&index=0&id=11f8236a&lang=scss&scoped=true&"
import style1 from "./PostListPlannedItem.vue?vue&type=style&index=1&id=11f8236a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f8236a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VDialog,VIcon,VTooltip})
